import {useQuery} from "@tanstack/react-query";
import { getAllTax} from "../../../store/Settings/api";

export const useGetTax = () => {
    const { data } = useQuery(["allTax"], getAllTax);
    return data?.data || []
}
